import React from 'react'
import { Paper } from '@mui/material';
import { BarChart, Bar,  XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';




class HeadquartersYearGoalChart extends React.Component {
    
    // eslint-disable-next-line no-useless-constructor
    constructor(props) {
        super(props);

    }

    render() {
        const { data } = this.props;

        return (
            <Paper sx={{ width: '100%', height: '400px', py:1, mt:1 }}>
                <ResponsiveContainer width="100%" height="100%">
                    <BarChart
                        
                        data={data}
                        margin={{
                            top: 20,
                            right: 30,
                            left: 20,
                            bottom: 5,
                          }}
                    >
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="dptNm" />
                        <YAxis width={100}/>
                        <Tooltip />
                        <Legend />
                        <Bar name="목표" dataKey="goal" stackId="a" fill="#8884d8" />
                        <Bar name="실적" dataKey="result" stackId="a" fill="#82ca9d" />
                    </BarChart>
                </ResponsiveContainer>

            </Paper>
        )
    }


}
export default HeadquartersYearGoalChart;